import React, { PureComponent } from "react";

import Routes from "../routes";

class App extends PureComponent {
  render() {
    return <Routes />;
  }
}

export default App;
